var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    staticClass: "triangle-element flex-shrink-0",
    class: _vm.colorCode,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }